export default "__VITE_ASSET__BLVb65FN__"